var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32933 14.6255C-5.33572 17.693 -1.76669 28.1625 13.4474 28.948C19.2414 29.2461 24.4348 28.237 28.2955 25.4906C32.1334 22.7614 31.0409 17.6184 24.0916 15.3365C23.451 15.1243 21.1861 14.465 20.6198 14.5624C19.4416 14.7746 19.0984 16.5348 21.0659 17.0164C33.8149 20.1412 27.0486 25.9665 17.0622 26.5341C6.49813 27.1362 -3.37962 21.8383 6.64684 17.8363C7.47046 17.5095 9.71254 17.0508 10.1987 16.7813C11.3598 16.1449 10.9651 14.2815 9.32933 14.6255Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0766 10.9961C14.0766 12.9857 14.0766 14.9752 14.0766 16.959C14.0766 18.3982 13.5332 21.8498 15.1919 21.9702C17.1309 22.1078 16.4788 18.5358 16.4788 17.154C16.4788 15.1014 16.4788 13.0488 16.4788 10.9961C16.7019 10.0042 20.9229 9.93543 20.6484 5.02176C20.2766 -1.59478 10.4904 -1.68652 9.92416 4.82682C9.67822 7.63627 11.1367 9.37927 13.293 10.3941C14.1223 10.784 13.7792 10.354 14.0823 10.9961H14.0766ZM14.5685 2.44165C10.6906 3.4909 12.172 9.21873 16.0784 8.24976C19.493 7.40692 18.4978 1.37521 14.5685 2.44165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationpin);
export default __webpack_public_path__ + "static/media/locationpin.94b3519a3b856853183679a8af9d07f0.svg";
export { ForwardRef as ReactComponent };